import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import './styles.scss'
import classNames from 'classnames'

const Button = ({ label, link, position, white }) => {
  const clsName = classNames({
    'main-button': true,
    'main-button center': position === 'center',
    'main-button center-high': position === 'center-high',
    'main-button right': position === 'right',
    'main-button white': white,
  })
  return (
    /* eslint-disable react/button-has-type */
    <Link to={link} className={clsName}>
      {label}
    </Link>
  )
}

export default Button

Button.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  position: PropTypes.string,
  white: PropTypes.bool,
}

Button.defaultProps = {
  position: '',
  white: false,
}
